// import axios from 'axios';
import api from './apiConfig';


export const login = async (credentials) => {
  try {
    const response = await api.post(`/auth/login`, credentials);

    // Extract the necessary data from the response
    const { token, id, username, user_email, logo, brandColor, serviceLevel, roleId } = response.data.data;

    // Check if the required fields are present
    if (!token || !id || !username || !user_email) {
      throw new Error('Required user data is missing in response');
    }

    // Store token
    localStorage.setItem('token', token);

    // Store user settings
    localStorage.setItem('userSettings', JSON.stringify({
      logo,
      brandColor,
      companyId: id,
      serviceLevel,
      roleId
    }));

    // Return user data as an object
    return { id, username, user_email, logo, brandColor, serviceLevel, roleId };

  } catch (error) {
    console.error('Login failed', error);
    throw error; // Ensure errors are caught in handleSubmit
  }
};

export function getUserServiceLevel() {
  const user = JSON.parse(localStorage.getItem('userSettings'));
  return user ? user.serviceLevel : 1;
}

export function getUserRoleID() {
  const user = JSON.parse(localStorage.getItem('userSettings'));
  return user ? user.roleId : 3;
}


export function getUserLogo() {
  const user = JSON.parse(localStorage.getItem('userSettings'));
  return user?.logo;
}

export function getUserColor() {
  const user = JSON.parse(localStorage.getItem('userSettings'));
  return user?.brandColor;
}


export const register = async (userData) => {
  try {
    const response = await api.post(`/auth/register`, userData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getProtectedData = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.get(`/protected-route`, {
      headers: { 'x-auth-token': token }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

//logout
export const logout = () => {
  localStorage.removeItem('token');

  localStorage.removeItem('userData');
  localStorage.removeItem('userSettings');
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};


// frontend/backend.js

export const requestPasswordReset = async (email) => {
  try {
    const response = await api.post(`/auth/password-reset-request`, { user_email: email });
    return response.data;
  } catch (error) {
    console.error('Password reset request failed', error);
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await api.post(`/auth/password-reset`, { token, newPassword });
    return response.data;
  } catch (error) {
    console.error('Password reset failed', error);
    throw error;
  }
};

